import { Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomAutocompleteMulti from "../../../common/components/functional/customAutocomplete/CustomAutocompleteMulti";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import TitleOptional from "../../../common/components/functional/titleOptional/TitleOptional";
import { AutocompleteType } from "../../../common/types/autoComplete";
import LanguagesTable from "./LanguagesTable";

type Props = {
  certificateOptions: AutocompleteType[];
  trainingOptions: AutocompleteType[];
};

const Requirements = ({ certificateOptions, trainingOptions }: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <FormSection title={<TitleOptional title={t("common:requirements")} />}>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography color="textSecondary" textAlign="end">
          {t("common:cardsAndCerts")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          control={control}
          name="certificates"
          render={({ field: { value, onChange } }) => (
            <CustomAutocompleteMulti
              name="certificates"
              defaultValue={value || []}
              options={certificateOptions.sort((a, b) =>
                a.name.localeCompare(b.name),
              )}
              onChange={(_: any, newValue: AutocompleteType[]) =>
                onChange(newValue)
              }
            />
          )}
        />
      </Grid>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography color="textSecondary">{t("common:trainings")}</Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          control={control}
          name="trainings"
          render={({ field: { value, onChange } }) => (
            <CustomAutocompleteMulti
              name="trainings"
              defaultValue={value || []}
              options={trainingOptions.sort((a, b) =>
                a.name.localeCompare(b.name),
              )}
              onChange={(_: any, newValue: AutocompleteType[]) =>
                onChange(newValue)
              }
            />
          )}
        />
      </Grid>
      <LanguagesTable />
    </FormSection>
  );
};

export default Requirements;
